import React from 'react';
import { FeatureAppConfig } from 'src/feature-app';
import {
	AltaComunicacionesTrigger,
	AutosubmitTrigger,
	BajaComunicacionesTrigger,
	CallMeEmbeddedTrigger,
	CallMeTrigger,
	CitaPosventaDealerTrigger,
	CitaPosventaEmbeddedTrigger,
	CitaPosventaTrigger,
	ConcursoRodajeTrigger,
	DiaDeLaMadreTrigger,
	EmpresasTrigger,
	EncuestasTrigger,
	EurocopaTrigger,
	FeedbackTrigger,
	FidelizacionTrigger,
	LeadDealerTrigger,
	LeadEmbededTrigger,
	LeadInPageTrigger,
	LeadTrigger,
	MGMTrigger,
	MyDealerTrigger,
	NavidadGTI2024Trigger,
	NavidadTrigger,
	NewsletterTrigger,
	PlanIdealTrigger,
	ProspectsEmbeddedTrigger,
	ProspectsInPageTrigger,
	ProspectsTrigger,
	RaceTrigger,
	SACTrigger,
	SuvperheroesTrigger,
	TestIDTrigger,
	TheOriginals2025Trigger,
	UGCTrigger,
	WidgetTrigger,
} from 'src/triggers';
import {
	GTI50LeadTelefonoTrigger,
	GTI50LeadTrigger,
} from 'src/triggers/adhoc/GTI50LeadTrigger';
import { NavidadGTI2025Trigger } from 'src/triggers/adhoc/NavidadGTI2025Trigger';
export interface TriggerProps {
	setCTALabel?: React.Dispatch<React.SetStateAction<string>>;
	setSelectedFocusJourney?: React.Dispatch<React.SetStateAction<JSX.Element>>;
	selectedFocusJourney?: JSX.Element;
	setSelectedJourney?: (
		selectedJourney: JSX.Element,
		skipTrackButtonClick?: boolean,
	) => void;
	action?: string;
}

export const getTrigger = (
	config: FeatureAppConfig,
	setSelectedJourney: (
		selectedJourney: JSX.Element,
		skipTrackButtonClick?: boolean,
	) => void,
	setCTALabel: React.Dispatch<React.SetStateAction<string>>,
	selectedJourney: JSX.Element,
	setSelectedFocusJourney: React.Dispatch<React.SetStateAction<JSX.Element>>,
	selectedFocusJourney: JSX.Element,
	triggerLoaded: React.MutableRefObject<string>,
): JSX.Element => {
	if (!config.trigger) {
		throw new Error('No trigger in Feature App Config.');
	}

	triggerLoaded.current = config.trigger;

	switch (config.trigger) {
		case 'alta-comunicaciones':
			return (
				<AltaComunicacionesTrigger
					setSelectedJourney={setSelectedJourney}
				/>
			);
		case 'autosubmit':
			return <AutosubmitTrigger />;
		case 'baja-comunicaciones':
			return (
				<BajaComunicacionesTrigger
					setSelectedJourney={setSelectedJourney}
				/>
			);
		case 'callme':
			return (
				<CallMeTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'callme-embedded':
			return (
				<CallMeEmbeddedTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'cita-posventa':
		case 'cita-posventa-tile-grid':
		case 'cita-posventa-tile':
			return (
				<CitaPosventaTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
					setSelectedFocusJourney={setSelectedFocusJourney}
					selectedFocusJourney={selectedFocusJourney}
				/>
			);
		case 'cita-posventa-dealer':
			return (
				<CitaPosventaDealerTrigger
					setSelectedJourney={setSelectedJourney}
				/>
			);
		case 'cita-posventa-embedded':
			return (
				<CitaPosventaEmbeddedTrigger
					setSelectedJourney={setSelectedJourney}
				/>
			);
		case 'empresas':
			return (
				<EmpresasTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'encuestas':
			return <EncuestasTrigger />;
		case 'feedback':
			return <FeedbackTrigger setSelectedJourney={setSelectedJourney} />;
		case 'lead':
			return (
				<LeadTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'lead-dealer':
			return (
				<LeadDealerTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'lead-embedded':
			return (
				<LeadEmbededTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'lead-inpage':
			return <LeadInPageTrigger />;
		case 'mgm':
			return (
				<MGMTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'mydealer':
			return (
				<MyDealerTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'newsletter':
			return (
				<NewsletterTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'prospect':
			return (
				<ProspectsTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'prospect-inpage':
			return <ProspectsInPageTrigger />;
		case 'prospect-embedded':
		case 'prospect-posventa-embedded':
			return (
				<ProspectsEmbeddedTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'race':
			return (
				<RaceTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'sac':
			return (
				<SACTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'ugc':
			return (
				<UGCTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'widget':
			return <WidgetTrigger setSelectedJourney={setSelectedJourney} />;

		// ADHOCS

		//case 'adhoc-lanzamiento-taigo':
		//	return <LanzamientoTaigoTrigger setSelectedJourney={setSelectedJourney} />;
		case 'adhoc-suvperheroes':
			return (
				<SuvperheroesTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'adhoc-2021-diamadre':
			return (
				<DiaDeLaMadreTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'adhoc-2021-eurocopa':
			return (
				<EurocopaTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'adhoc-2021-navidad':
			return (
				<NavidadTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'adhoc-2021-fidelizacion_clientes':
			return (
				<FidelizacionTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'adhoc-2023-test_id':
			return (
				<TestIDTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'adhoc-2023-concurso_rodaje':
			return <ConcursoRodajeTrigger />;
		case 'adhoc-2023-plan_ideal':
			return (
				<PlanIdealTrigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'adhoc-2024-navidad_gti':
			return <NavidadGTI2024Trigger />;
		case 'adhoc-2025-the_originals':
			return (
				<TheOriginals2025Trigger
					setSelectedJourney={setSelectedJourney}
					setCTALabel={setCTALabel}
				/>
			);
		case 'adhoc-2025-gti50_leads':
			return <GTI50LeadTrigger />;
		case 'adhoc-2025-gti50_leads_telefono':
			return <GTI50LeadTelefonoTrigger />;
		case 'adhoc-2025-navidad_gti':
			return <NavidadGTI2025Trigger />;

		default:
			triggerLoaded.current = null;
			throw new Error(
				"The config trigger defined in CMS doesn't match with any trigger in One Form",
			);
	}
};
